/* ==========================================================================
   "Discover our flavors" dialog.

   The mockups open the flavours grid as a dialog from the first story row.
   In the theme that link is a story-section button of type "modal", which
   the section renders with onclick="openTeasModal()" -- and until now
   nothing on the page defined that function, nor the #flavorsModal it was
   meant to open. The link did nothing on every product page.

   flavors-section.liquid now renders the (empty) dialog shell; this file
   fills it on first open by cloning the section's own grid, so there is one
   copy of the copy and of the photographs, and defines both names the
   templates use: openFlavorsModal (the mockups' name) and openTeasModal (the
   story button's).

   Bound on DOMContentLoaded on purpose: story-section.js also defines
   openFlavorsModal when it finds #flavorsModal, but looks the grid up by an
   id most templates never set, so it would open an empty dialog. Deferred
   scripts have all run by DOMContentLoaded, so the definition made here is
   the one that stands.
   ========================================================================== */
(function () {
  'use strict';

  function boot() {
    var modal = document.getElementById('flavorsModal');
    if (!modal) return;

    var body = document.getElementById('flavorsModalBody');
    var lastFocus = null;

    function fill() {
      if (!body || body.childElementCount) return;
      var source = document.querySelector('[data-gio-flavors-source] .flavors');
      if (source) body.innerHTML = source.innerHTML;
    }

    function open() {
      fill();
      lastFocus = document.activeElement;
      modal.classList.add('open');
      document.body.style.overflow = 'hidden';
      var panel = modal.querySelector('.gio-flavors-modal__panel');
      if (panel) panel.scrollTop = 0;
      var close = document.getElementById('flavorsCloseBtn');
      if (close) close.focus();
    }

    function close() {
      if (!modal.classList.contains('open')) return;
      modal.classList.remove('open');
      document.body.style.overflow = '';
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    window.openFlavorsModal = open;
    window.openTeasModal = open;

    // "Our flavors" beside the flavour step's heading opens this same dialog.
    document.addEventListener('click', function (event) {
      var link = event.target.closest && event.target.closest('[data-gg-our-flavors]');
      if (!link) return;
      event.preventDefault();
      open();
    });

    modal.addEventListener('click', function (event) {
      if (event.target === modal || event.target.closest('#flavorsCloseBtn')) close();
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') close();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
